import { render, staticRenderFns } from "./LittleSpinner.vue?vue&type=template&id=200e61cf"
import script from "./LittleSpinner.vue?vue&type=script&lang=js"
export * from "./LittleSpinner.vue?vue&type=script&lang=js"
import style0 from "./LittleSpinner.vue?vue&type=style&index=0&id=200e61cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports